const InteractionType = {
  BOOKMARK: 'bookmarks',
  LIKE: 'likes',
  READ: 'reads',
  PIN: 'pins',
  FAVOURITE: 'favourites',
};

export default InteractionType;
